export const Props = () => ({
  //--------------------------------------------------------------------------
  //                                      Объект поста
  //--------------------------------------------------------------------------
  post: {
    type: Object,
    required: true,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
  //--------------------------------------------------------------------------
  //                                      Тип поста - альфа или инфошум
  //--------------------------------------------------------------------------
  type: {
    type: String,
    default: 'other'
  }
});
